module.exports = __webpack_public_path__ + "static/media/human-advantage-star.10259330.svg";